/* eslint-disable */
import axios from "axios";
import "../utils/axios.interceptor";
import { format } from "date-fns";
import { urlCoreBack } from "../../project/configs/config";

const epNameEnvioActualizar = "v1/envio-articulo/?&accion=actualizar";
const epNameEnviorecibir = "v1/envio-articulo/?&accion=recibir";
const epNameEnvio = "v1/envio-articulo/?"
const epNameEnvioArticulo = "v1/envio-articulo/";
const epNameRecibirArticulo = "v1/envio-articulo/recibir/";
const textNameEnvio = "Envio de Artículos";
const itemGender = "M";
const elLa = itemGender === "M" ? "el" : "la";
//
// #############################################################################
//
export const getEnvios = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Envios";

  if (params) {
    if (params.idAreaDestino) {
      _params.id_area_destino = params.idAreaDestino;
    }
    if (params.usuario) {
      _params.usuario = params.usuario;
    }
    if (params.fechaCreacionDesde) {
      _params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
    }
    if (params.fechaCreacionHasta) {
      _params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
    }
    if (params.estadoActual) {
      _params.estado_actual = params.estadoActual;
    }
    if (params.usuario) {
      _params.id_usuario = params.usuario;
    }

    if (params.codigo) {
      _params.codigo = params.codigo;
    }
    if (params.rows) {
      _params.rows = params.rows;
    }

    if (params.first) {
      _params.first = params.first;
    }

  }
  _params.id_area_origen = localStorage.getItem("id_area_ventas");

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameEnvioActualizar}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado 
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    let _message_code = response.data.message_code;
    if (_message_code === "err-caja-mdc-os-plan-invalid") {
      response.messageText = `El Plan de Obra Social no es válido`;
    } else {
      response.messageText = _errorMessage;
    }
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getEnvio = async (parIdEnvio) => {
  let _errorMessage = "Se produjo un error al obtener el Envio";
  let _params = {};

  _params.id = parIdEnvio;
  _params.id_area_solicita = localStorage.getItem("id_area_ventas");

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameEnvio}`,
      params: _params
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const saveEnvioArticulo = async (parAction, parEnvioArticulo) => {

  let _errorMessage = "";

  if (parAction === "new" || parAction === "update") {
    _errorMessage = "No fue posible guardar el Envio de Artículos";
    parEnvioArticulo.id_area_origen = localStorage.getItem("id_area_ventas");
  } else {
    _errorMessage = "No fue posible anular el Envio de Artículos";
    parEnvioArticulo.id_area = localStorage.getItem("id_area_ventas");
  }
  parEnvioArticulo.id_usuario = localStorage.getItem("id_usuario");

  try {
    let response = {};
    if (parAction === "new") {
      response = await axios({
        method: "POST",
        url: `${urlCoreBack}${epNameEnvioArticulo}`,
        data: parEnvioArticulo,
      });
    } else if (parAction === "update") {
      response = await axios({
        method: "PUT",
        url: `${urlCoreBack}${epNameEnvioArticulo}`,
        data: parEnvioArticulo,
      });
    } else {
      response = await axios({
        method: "DELETE",
        url: `${urlCoreBack}${epNameEnvioArticulo}`,
        params: parEnvioArticulo,
      });
    }

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = `Envio de Artículos ${["new", "update"].includes(parAction) ? "guardado" : "anulado"}`;
        response.messageSeverity = "success";
        return response;
      }

      if (response.data.code === "err-envio-articulo-cantidad-disponible-insuficiente") {
        // En caso de error busco marca y modelo de producto y lo muestro en el mensaje
        response.ok = false;
        response.messageText = "Cantidad disponible insuficiente";
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-envio-articulo-delete-not-allowed") {
        // En caso de error busco marca y modelo de producto y lo muestro en el mensaje
        response.ok = false;
        response.messageText = "No fue opsible anular el Envio de Artículos";
        response.messageSeverity = "error";
        return response;
      }

      if (response.data.code === "err-envio-articulo-modify-not-allowed") {
        // En caso de error busco marca y modelo de producto y lo muestro en el mensaje
        response.ok = false;
        response.messageText = "No fue opsible modificar el Envio de Artículos";
        response.messageSeverity = "error";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const recibirEnvioArticulo = async (parEnvioArticulo) => {
  let _errorMessage = `No fue posible Recibir ${elLa} ${textNameEnvio}`;

  parEnvioArticulo.id_area = localStorage.getItem("id_area_ventas");
  parEnvioArticulo.id_usuario = localStorage.getItem("id_usuario");

  try {
    const response = await axios({
      method: "PUT",
      url: `${urlCoreBack}${epNameRecibirArticulo}`,
      data: parEnvioArticulo,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado
        response.ok = true;
        response.messageText = "Envio de Artículos recibido";
        response.messageSeverity = "success";
        return response;
      }
    }

    console.log(_errorMessage);
    console.log(response);

    response.messageText = _errorMessage;
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  }
  catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
//
// #############################################################################
//
export const getEnviosRecibir = async (params) => {
  let _params = {};
  let _errorMessage = "Se produjo un error al obtener Envios";

  let id_area_destino = localStorage.getItem("id_area_ventas");

  if (params) {
    if (params.idAreaOrigen) {
      _params.id_area_origen = params.idAreaOrigen;
    }
    if (params.usuario) {
      _params.usuario = params.usuario;
    }
    if (params.fechaCreacionDesde) {
      _params.fecha_creacion_desde = format(params.fechaCreacionDesde, "yyyy/MM/dd");
    }
    if (params.fechaCreacionHasta) {
      _params.fecha_creacion_hasta = format(params.fechaCreacionHasta, "yyyy/MM/dd");
    }
    if (params.estadoActual) {
      _params.estado_actual = params.estadoActual;
    }
    if (params.usuario) {
      _params.id_usuario = params.usuario;
    }

    if (params.codigo) {
      _params.codigo = params.codigo;
    }
    if (params.rows) {
      _params.rows = params.rows;
    }

    if (params.first) {
      _params.first = params.first;
    }

  }
  _params.id_area_destino = id_area_destino;

  try {
    const response = await axios({
      method: "GET",
      url: `${urlCoreBack}${epNameEnviorecibir}`,
      params: _params,
    });

    if (response.status === 200) {
      let _error = "status" in response.data && response.data.status === "error";
      if (!_error) {
        // si no hay error controlado 
        response.ok = true;
        return response;
      }
    }

    // si hay algun error controlado

    console.log(_errorMessage);
    console.log(response);

    let _message_code = response.data.message_code;
    if (_message_code === "err-caja-mdc-os-plan-invalid") {
      response.messageText = `El Plan de Obra Social no es válido`;
    } else {
      response.messageText = _errorMessage;
    }
    response.ok = false;
    response.messageSeverity = "error";
    return response;
  } catch (error) {
    console.log(_errorMessage);
    if (error.response) {
      // The request was made and the server responded with a status code that falls out of the range of 2xx
      console.log(error.response);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(error);
    }
    let response = {};
    response.ok = false;
    response.messageText = _errorMessage;
    response.messageSeverity = "error";
    return response;
  }
};
